import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import HomeTopCard from "../../../components/HomeComponents/HomeTopCard";
import "../userDashboard.css";
import AudioBookPlayerBig from "../../../components/sharedcomponents/AudioPlayerBigComp";
import AudioBookPlayerBigNew from "../../../components/sharedcomponents/AudinPlayerBigCompB";

export const UserBooksAudioPage = () => {

  return (
    <>
      <div style={{ minHeight: "400px" }}>
        {/* <TopBar displayType="logo" showNotification showProfileBtn></TopBar> */}
        {/* <AudioBookPlayerBig></AudioBookPlayerBig> */}
        <AudioBookPlayerBigNew></AudioBookPlayerBigNew>
      </div>
    </>
  );
};

export default UserBooksAudioPage;
